import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDebounce } from 'react-use';

import { SearchInput } from '@sorare/core/src/atoms/inputs/SearchInput';

type Props = {
  onChange: (value: string) => void;
  value: string;
  collectionsCount: number;
};

export const LeagueSearchInput = ({
  onChange,
  value: initialValue,
  collectionsCount,
}: Props) => {
  const { formatMessage } = useIntl();
  const [value, setValue] = useState(initialValue);
  useDebounce(
    () => {
      onChange(value);
    },
    300,
    [value]
  );

  return (
    <SearchInput
      fullWidth
      small
      rounded
      withIcon
      value={value}
      onChange={event => {
        setValue(event.target.value);
      }}
      placeholder={formatMessage(
        {
          defaultMessage: 'Search {collectionsCount} collections',
        },
        { collectionsCount }
      )}
    />
  );
};
